var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-upload',{attrs:{"name":"avatar","show-upload-list":false,"customRequest":_vm.uploadImg,"before-upload":_vm.beforeUpload,"accept":".srt"},on:{"change":_vm.handleChange}},[_c('div',[_c('a-button',[_c('a-icon',{attrs:{"type":_vm.loading ? 'loading' : 'upload'}}),_vm._v("点击上传")],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }